import { render, staticRenderFns } from "./change-passengers.vue?vue&type=template&id=0481a3aa&"
import script from "./change-passengers.vue?vue&type=script&lang=js&"
export * from "./change-passengers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports